// extracted by mini-css-extract-plugin
export default {"container":"ProjectPage_container__SCvBF"};